import { render, staticRenderFns } from "./CommonTextarea.vue?vue&type=template&id=16ac5435&scoped=true&"
import script from "./CommonTextarea.vue?vue&type=script&lang=ts&"
export * from "./CommonTextarea.vue?vue&type=script&lang=ts&"
import style0 from "./CommonTextarea.vue?vue&type=style&index=0&id=16ac5435&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ac5435",
  null
  
)

export default component.exports